__turbopack_context__.v({
  "caption": "Image-module__8svD9W__caption",
  "figure": "Image-module__8svD9W__figure",
  "fillWrapper": "Image-module__8svD9W__fillWrapper",
  "image": "Image-module__8svD9W__image",
  "link": "Image-module__8svD9W__link",
  "placeholderPixel": "Image-module__8svD9W__placeholderPixel",
  "staticWrapper": "Image-module__8svD9W__staticWrapper",
});
